export const isSandboxUrl = (url: string): boolean => {
  return /sandbox(\.oci)?\.faire\.team/.test(url);
};
